var map = {
	"./arg.svg": 696,
	"./aus.svg": 697,
	"./bel.svg": 698,
	"./bra.svg": 699,
	"./can.svg": 700,
	"./cmr.svg": 701,
	"./crc.svg": 702,
	"./cro.svg": 703,
	"./den.svg": 704,
	"./ecu.svg": 705,
	"./eng.svg": 706,
	"./esp.svg": 707,
	"./fra.svg": 708,
	"./ger.svg": 709,
	"./gha.svg": 710,
	"./irn.svg": 711,
	"./jpn.svg": 712,
	"./kor.svg": 713,
	"./ksa.svg": 714,
	"./mar.svg": 715,
	"./mex.svg": 716,
	"./ned.svg": 717,
	"./pol.svg": 718,
	"./por.svg": 719,
	"./qat.svg": 720,
	"./sen.svg": 721,
	"./srb.svg": 722,
	"./sui.svg": 723,
	"./tun.svg": 724,
	"./uru.svg": 725,
	"./usa.svg": 726,
	"./wal.svg": 727
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2332;